const BANNER_TYPES = {
    TOP: 'top',
    SIDE: 'side',
    TGBM_7: 'tgbm7',
    OUT_OF_PAGE: 'outOfPage',
    TGB_BOTTOM: 'tgbBottom',
};
const BANNER_TYPES_WITH_PLACEHOLDERS = [BANNER_TYPES.TGBM_7, BANNER_TYPES.SIDE, BANNER_TYPES.TOP];
const DEFAULT_HAS_PLACEHOLDER = {
    [BANNER_TYPES.TGBM_7]: true,
    [BANNER_TYPES.SIDE]: true,
    [BANNER_TYPES.TOP]: false,
    [BANNER_TYPES.OUT_OF_PAGE]: false,
    [BANNER_TYPES.TGB_BOTTOM]: true,
};
const OUT_OF_PAGE_TYPES = {
    FULLSCREEN: 'FullScreen',
    MOBILE_BOTTOM: 'MobileBottom',
};

export { BANNER_TYPES, BANNER_TYPES_WITH_PLACEHOLDERS, DEFAULT_HAS_PLACEHOLDER, OUT_OF_PAGE_TYPES };
//# sourceMappingURL=banner.js.map
